var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomLeft"}},[_c('div',{staticClass:"bg-color-black"},[_vm._m(0),_c('div',{staticClass:"body-box"},[(_vm.show)?_c('WashingVolumeChart',{attrs:{"data":_vm.result}}):_vm._e()],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex title-box"},[_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"fs-xl text_title mx-2 commonTitle"},[_vm._v("近一年洗涤量趋势")])])])
}]

export { render, staticRenderFns }